module.exports = __webpack_public_path__ + "img/x-diamond.c7baa8bd.svg";